import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import AppointmentForm from '@/components/forms/AppointmentForm';

const InvisalignSpecial = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>FREE Invisalign Consultation | Clear Aligners | Fort Worth Dental</title>
        <meta name="description" content="FREE Invisalign consultation at Fort Worth Dental! Straighten teeth without metal braces. Expert Invisalign provider Dr. Razo. Fort Worth TX. Call (817) 985-3337." />
        <link rel="canonical" href="https://fortworthdental.com/specials/invisalign" />
      </Helmet>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-purple-600 to-purple-800 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">Invisalign® – Free Consultation</h1>
          <p className="text-xl">Fort Worth Dental is now offering FREE CONSULTATION for Invisalign®</p>
        </div>
      </section>

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-5xl mx-auto">
          
          {/* Main Content Section */}
          <section className="mb-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
              <div>
                <h2 className="text-3xl font-bold text-gray-800 mb-4">
                  Invisalign® – Free Consultation
                </h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-6">
                  Fort Worth Dental is now offering <strong>FREE CONSULTATION for Invisalign®</strong>.
                </p>
                <p className="text-gray-700 text-lg leading-relaxed mb-6">
                  <strong>Invisalign®</strong> is the clear way to straighten teeth without braces, using aligners. 
                  Aligners are removable and virtually invisible, which means you can straighten your teeth without 
                  anyone knowing; and you can still eat and drink what you want. Also, you can brush and floss normally 
                  to maintain healthy gums and teeth; and there are no wires, metal or brackets to cause mouth abrasions.
                </p>
                <p className="text-gray-700 text-lg leading-relaxed mb-6">
                  Call today for your FREE Invisalign® Consultation to see if Invisalign® is right for you.
                </p>
                <a 
                  href="tel:8179853337" 
                  className="inline-block bg-purple-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-purple-700 transition-colors"
                >
                  Call (817) 985-3337
                </a>
              </div>
              <div>
                <img 
                  src="/images/services/invisalign-clear-aligner.jpg" 
                  alt="Invisalign Clear Aligners" 
                  className="rounded-lg shadow-lg w-full mb-6"
                  onError={(e) => e.target.src = '/images/services/frame-1288-2.png'}
                />
              </div>
            </div>
          </section>

          {/* YouTube Video Section */}
          <section className="mb-12">
            <div className="aspect-video max-w-3xl mx-auto rounded-lg overflow-hidden shadow-lg">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/briV8y-vuuM"
                title="Invisalign Clear Aligners"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
          </section>

          {/* CTA Section */}
          <section className="mb-12 bg-gradient-to-r from-purple-600 to-purple-700 text-white p-12 rounded-lg text-center">
            <h2 className="text-3xl font-bold mb-4">Ready to Schedule Your Free Invisalign® Consultation?</h2>
            <p className="text-xl mb-8">Take the first step toward your perfect smile today</p>
            <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
              <a 
                href="tel:8179853337" 
                className="bg-white text-purple-600 px-8 py-4 rounded-lg text-lg font-bold hover:bg-gray-100 transition-colors"
              >
                Call (817) 985-3337
              </a>
              <Link 
                to="/invisalign" 
                className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-teal-700 transition-colors"
              >
                Learn More About Invisalign®
              </Link>
            </div>
          </section>

          {/* Testimonial Section */}
          <section className="mb-12 bg-gray-50 p-8 rounded-lg">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">What Others Are Saying</h3>
            <blockquote className="text-gray-700 text-lg italic mb-4">
              "I always wanted straight teeth but never wanted metal braces as an adult. Invisalign at Fort Worth 
              Dental was the perfect solution! The aligners were comfortable and no one even noticed I was wearing them. 
              Now I have the smile I always wanted!"
            </blockquote>
            <p className="text-purple-600 font-semibold">— Candice W.</p>
          </section>

          {/* What You'll Get Section */}
          <section className="mb-12">
            <h3 className="text-3xl font-bold text-gray-800 mb-6">What You'll Get with Your FREE Consultation:</h3>
            <ul className="space-y-4 text-gray-700 text-lg">
              <li className="flex items-start">
                <span className="text-purple-600 mr-3 text-2xl">✓</span>
                <span>Complete smile evaluation</span>
              </li>
              <li className="flex items-start">
                <span className="text-purple-600 mr-3 text-2xl">✓</span>
                <span>Discussion of your treatment goals</span>
              </li>
              <li className="flex items-start">
                <span className="text-purple-600 mr-3 text-2xl">✓</span>
                <span>Custom treatment timeline</span>
              </li>
              <li className="flex items-start">
                <span className="text-purple-600 mr-3 text-2xl">✓</span>
                <span>Pricing and payment options</span>
              </li>
              <li className="flex items-start">
                <span className="text-purple-600 mr-3 text-2xl">✓</span>
                <span>Special financing available</span>
              </li>
            </ul>
          </section>

          {/* Appointment Form */}
          <section>
            <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
              Schedule Your FREE Invisalign® Consultation
            </h2>
            <p className="text-gray-600 text-center mb-8">
              Fill out the form below or call us at <a href="tel:8179853337" className="text-purple-600 font-semibold">(817) 985-3337</a>
            </p>
            <AppointmentForm />
          </section>

        </div>
      </div>
    </div>
  );
};

export default InvisalignSpecial;
